import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { LeeftijdsCategorieIcon } from "../../atoms/icons/LeeftijdsCategorieIcon";

// All the incoming values
interface IProps {
    birthDate?: Date | null;
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & Omit<IDefaultViewProps<string | null>, 'value'>;
export const LeeftijdsCategorie = (props: AllProps) => {
    const calculateAge = (birthDate: Date | null): number | null => {
        if (!birthDate) return null;
        return Math.floor((new Date().getTime() - new Date(birthDate).getTime()) / (1000 * 60 * 60 * 24 * 365.25));
    };

    const calculateAgeCategory = (age: number | null): string => {
        if (age === null) return '-';
        if (age <= 10) return '0-10';
        const decade = Math.floor(age / 10) * 10;
        return `${decade + 1}-${decade + 10}`;
    };

    const age = calculateAge(props.birthDate || null);

    return (<Caption {...props} caption={props.label || "Leeftijdscategorie"} icon={<LeeftijdsCategorieIcon />}>
        {calculateAgeCategory(age)}
    </Caption>)
}

